import { apiService } from './apiService';
import { EmailTemplate, EmailTemplateType, PreviewResponse } from '../types/emailTemplate';

class EmailTemplateService {
  /**
   * Retrieve an email template by type
   * @param type - The email template type ('welcome' or 'training_assignment')
   * @returns The email template with subject, HTML body, plain text body, and available variables
   */
  async getEmailTemplate(type: EmailTemplateType): Promise<EmailTemplate> {
    return apiService.get<EmailTemplate>(`/admin/email-templates/${type}`);
  }

  /**
   * Update an email template by type
   * @param type - The email template type ('welcome' or 'training_assignment')
   * @param template - The template data to save (subject, htmlBody, plainTextBody)
   * @returns Success response
   */
  async updateEmailTemplate(
    type: EmailTemplateType,
    template: Omit<EmailTemplate, 'type' | 'availableVariables'>
  ): Promise<{ success: boolean; message: string }> {
    return apiService.put<{ success: boolean; message: string }>(
      `/admin/email-templates/${type}`,
      template
    );
  }

  /**
   * Preview an email template with sample data
   * @param type - The email template type ('welcome' or 'training_assignment')
   * @param template - The template data to preview (subject, htmlBody, plainTextBody)
   * @returns Rendered template with sample data
   */
  async previewEmailTemplate(
    type: EmailTemplateType,
    template: Omit<EmailTemplate, 'type' | 'availableVariables'>
  ): Promise<PreviewResponse> {
    return apiService.post<PreviewResponse>(
      `/admin/email-templates/${type}/preview`,
      template
    );
  }
}

export const emailTemplateService = new EmailTemplateService();
